<template>
<div v-if="billInfo" class="tab-wrapper">
  <h3 class="mb16">付款计划</h3>
  <div class="content">
    <div class="item pt16 pb16">
      <table-list :showPage ="false" :columns="columns" :data="billInfo" :loading="loading"></table-list>
    </div>
  </div>
</div>
 
</template>
 
<script type="text/ecmascript-6">
 import TableList from "components/TableList/index";
export default {
  props:{
    billInfo:{
      type:Array,
      default:null
    }
  },
components:{
  TableList
},
 data () {
  return {
    loading:false,
    columns:[
    {
      title: "期数",
      key: "periods",
      align: "center"
     
    },
    {
      title: "款项",
      key: "costCodeName",
      align: "center"
    },
    {
      title: "应收款日期",
      key: "preCollectionDate",
      align: "center"
    },
    {
      title: "账单周期",
      key: "billPeriods",
      align: "center",
      width:180,
      render: (h,params)=>{
        return h('span',`${params.row.billsycleStarttime}至${params.row.billsycleEndtime}`)
      }
    },
    {
      title: "应收",
      key: "receiptBillAmount",
      align: "center",
      render: (h,params) => {
        let receiptBillAmount = params.row.receiptBillAmount === 0 ? 0 : (params.row.receiptBillAmount/100).toFixed(2)
        return h('span',receiptBillAmount)
      }
    },
    {
      title: "已收",
      key: "receivedBillAmount",
      align: "center",
      render: (h,params) => {
        let receivedBillAmount = params.row.receivedBillAmount === 0 ? 0 : (params.row.receivedBillAmount/100).toFixed(2)
        return h('span',receivedBillAmount)
      }
    },
    {
      title: "状态",
      key: "verificateStatusName",
      align: "center"
    },
    {
      title: "账单编号",
      key: "billNum",
      align: "center"
    }
    ],
   tableData:[]
 };
 },
 methods:{

 }
}
</script>




